import { hotjar } from 'react-hotjar';
export function initHotjar(user, tenantId) {
    if (user.email.includes('farseer.io')) {
        return;
    }
    hotjar.initialize(Number(process.env.HOTJAR_ID), Number(process.env.HOTJAR_SITE_VERSION));
    hotjar.identify(user.email, {
        firstName: user.firstName,
        lastName: user.lastName,
        keycloakId: user.keycloakId,
        tenantId: tenantId,
    });
}
